import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    private language = new BehaviorSubject<string>('es'); // Idioma por defecto
    private translations = new BehaviorSubject<any>({}); // Guardamos las traducciones reactivamente

    constructor(private http: HttpClient) {
        const savedLang = localStorage.getItem('language') || 'es'; // Si no hay idioma, usa 'es'
        this.language.next(savedLang);
        this.loadTranslations(savedLang);
    }

    setLanguage(lang: string) {
        this.language.next(lang);
        localStorage.setItem('language', lang);
        this.loadTranslations(lang);
    }


    getLanguage() {
        return this.language.asObservable(); // Retorna el idioma actual como Observable
    }

    getTranslations() {
        return this.translations.asObservable(); // Retorna las traducciones como Observable
    }

    private loadTranslations(lang: string) {
        const path = `/assets/i18n/${lang}.json`;

        this.http.get(path).subscribe({
            next: (data) => {
                this.translations.next(data); // 🔹 Actualiza las traducciones reactivamente
            },
            error: (err) => {
                console.error(`❌ Error cargando traducciones (${lang}): ${err.message}`);
            }
        });
    }

    translate(key: string): string {
        const currentTranslations = this.translations.getValue();
        return currentTranslations[key] || key; // 🔹 Si no existe, devuelve la clave
    }
}
